export default __webpack_public_path__ + "static/media/Photo 5 - MR - feuillages.7921ac99.jpg";